import { loadScript } from '@/js/helpers/scripts'
import type { IRogue } from '@/js/services/RogueTypes'

declare global {
  interface Window {
    BV: any
  }
}

/**
 * BazaarVoice renders its "My Review" submission form into a container that it appends
 * directly to the <body>, outside of the Vue app. Nothing about that container is tied to
 * the component that opened it, so when that component unmounts on a SPA page change the
 * modal just stays on screen on top of whatever page the customer navigated to. The only
 * way BV tears it down is its own X button, so the component that opened it has to close
 * it when it goes away.
 */
const SUBMISSION_CONTAINER = 'div[data-bv-show="inpage_submission"]'

export async function openReviewSubmission(sku: string, rogue: IRogue) {
  await loadScript('BV', rogue)

  if (window.BV) {
    window.BV.ui('rr', 'submit_review', { productId: sku })
  }
}

/**
 * Closes any open BV review submission modal and removes the container it left behind.
 * BV offers no public teardown API, so we click its own close button first (which lets BV
 * run its teardown) and then drop the now empty container. BV builds a fresh container on
 * the next BV.ui() call, so removing it does not break opening a review later.
 */
export function closeReviewSubmission() {
  if (typeof document === 'undefined' || !document) {
    return
  }

  const containers = document.querySelectorAll<HTMLElement>(SUBMISSION_CONTAINER)

  for (let i = 0; i < containers.length; i += 1) {
    const close = containers[i].querySelector<HTMLButtonElement>('button[aria-label^="Close"]')

    close?.click()
    containers[i].remove()
  }
}
